import type { UpdateCustomer } from '@weft/types';
import { UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT } from '@weft/types';
import { isNotNullOrUndefined } from '@weft/utils';
import { CountriesSelect, useCountriesFilter } from 'apps/app/src/components/design/selects/CountriesSelect';
import React, { useState } from 'react';
import { Controller, get, useFormContext } from 'react-hook-form';
import { Input } from '../../../../components/design/Input';
import { CustomerViewPropertiesBlock } from './CustomerViewPropertiesBlock';

export const CustomerInfoViewEditAddress: React.FC = () => {
  const { getValues, register, formState: { errors }, setValue, resetField, trigger } = useFormContext<UpdateCustomer>();
  const [isInEditMode, setIsInEditMode] = useState(false);

  const cityRegister = register('address.city');
  const addressTextRegister = register('address.addressText');
  const postalCodeRegister = register('address.postalCode');

  const filterCountry = useCountriesFilter();

  const handleCancelClick = () => {
    resetField('address.city');
    resetField('address.addressText');
    resetField('address.postalCode');
  };

  const handleSaveClick = () => {
    return trigger(['address.city', 'address.addressText', 'address.postalCode']);
  };

  return (
    <CustomerViewPropertiesBlock
      title='Address'
      showEditButton
      onEditChange={setIsInEditMode}
      childrenContainerClassName='items-end'
      sectionToSubmit={UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT.address}
      onCancel={handleCancelClick}
      onSave={handleSaveClick}
    >

      <div className='flex w-1/5 max-w-[20%] flex-1 flex-col pr-6'>
        <Controller
          name="address.country"
          render={({ field }) => (
            <CountriesSelect
              {...field}
              helperText={get(errors, 'address.country')?.message}
              error={isNotNullOrUndefined(get(errors, 'address.country'))}
              onChange={(_, value) => {
                const country = filterCountry(value?.name);
                setValue('address.country', country?.name ?? '');
              }}
              textFieldProps={{
                focused: isInEditMode,              
              }}
              disabled={!isInEditMode}
            />
          )}
        />
      </div>

      <div className='flex w-1/5 flex-col border-0 pr-6'>
        <Input
          label='City'
          {...cityRegister}
          debounce={false}
          editModeOverride
          isInEditModeOverride={isInEditMode}
          defaultValue={getValues('address.city')}
          editMode
          placeholder="Text here"
        />
      </div>

      <div className='flex w-1/5 flex-col border-0 pr-6'>
        <Input
          label='Address'
          {...addressTextRegister}
          debounce={false}
          editModeOverride
          isInEditModeOverride={isInEditMode}
          defaultValue={getValues('address.addressText')}
          editMode
          placeholder="Text here"
        />
      </div>

      <div className='flex w-1/5 flex-col border-0 pr-6'>
        <Input
          label='Postal Code'
          {...postalCodeRegister}
          debounce={false}
          editModeOverride
          isInEditModeOverride={isInEditMode}
          defaultValue={getValues('address.postalCode')}
          editMode
          placeholder="Text here"
        />
      </div>
    </CustomerViewPropertiesBlock>
  );
};